// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e6ecdc6b","239":"ad3e46e7","455":"8d9c47a4","948":"a3dfedda"}[chunkId] + ".chunk.js";
};